import { clone } from "./utils";

export class Stack<T> {
	constructor(private capcity: number = 20) {}

	private _items: T[] = [];

	public push(item: T): void {
		if (this._items.length >= this.capcity) {
			this._items.shift();
		}

		this._items.push(item);
	}

	public pop(): T | undefined {
		return this._items.pop();
	}

	public peek(): T | undefined {
		return this._items[this._items.length - 1];
	}

	public length(): number {
		return this._items.length;
	}

	public clear(): void {
		this._items = [];
	}

	public toArray(): T[] {
		return clone(this._items);
	}
}
